import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { AlertTitle, Box } from '@mui/material';
import React, { useMemo } from 'react';

import { UploadCsvStatusEnum, WIDTH_MODAL_COMPONENTS } from '../../../../constants/addressBook';
import Dropzone from '../../../Dropzone/Dropzone';
import NotificationAlert, { AlertLink } from '../../../_mui/_alerts_/NotificationAlert';
import { AlertBody, AlertTable, FilePreview } from '../components';
import { useUploadModal } from '../UploadModalContext';

const UploadAddressesStep: React.FC = () => {
  const { fileCSV, status, handleUploadFile, handleDeleteFile, handleFileSizeError, clearModalState, profile } =
    useUploadModal();
  const preparingCsvAlert = profile.copy.preparingCsvAlert;

  const showFilePreview = useMemo(() => {
    switch (true) {
      case !!fileCSV:
        return <FilePreview file={fileCSV} status={status} onDelete={handleDeleteFile} />;
      case status === UploadCsvStatusEnum.ErrorLargeFile:
        return <FilePreview status={status} onDelete={clearModalState} />;
      default:
        return null;
    }
  }, [fileCSV, status]);

  return (
    <>
      <Box sx={{ mt: 10, mx: 'auto', maxWidth: WIDTH_MODAL_COMPONENTS }}>
        <NotificationAlert type={preparingCsvAlert.type}>
          <AlertTitle>{preparingCsvAlert.title}</AlertTitle>
          <AlertBody />
          <AlertTable />
          <AlertLink icon={<SaveAltIcon />} href={preparingCsvAlert.link} download>
            {preparingCsvAlert.linkText}
          </AlertLink>
        </NotificationAlert>
      </Box>
      <Box sx={{ mt: 4, mb: 1 }}>
        <Dropzone
          onFileAccepted={handleUploadFile}
          status={status}
          dataAction="upload_addresses_step_dropzone"
          handleFileSizeError={handleFileSizeError}
          maxSize={profile.fileSizeByteLimit}
        />
      </Box>
      {showFilePreview}
    </>
  );
};

export default UploadAddressesStep;
